import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

const StoreDetailImage = (_param)=> {
    var { className , storeDetailImageUrl , isFallbackImage , width , height , alt  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "storeDetailImageUrl",
        "isFallbackImage",
        "width",
        "height",
        "alt"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames(className, 'store-detail-image-stores-v2', {
            'store-detail-image-stores-v2--fallback': isFallbackImage
        })
    }), /*#__PURE__*/ React__default.createElement("img", {
        className: "store-detail-image-stores-v2__image",
        "data-t": "StoreDetailImage",
        alt: alt,
        src: storeDetailImageUrl,
        width: width,
        height: height
    }));
};
var StoreDetailImage$1 = StoreDetailImage;

export { StoreDetailImage$1 as default };
//# sourceMappingURL=StoreDetailImage.js.map
